import { Box, Flex, Skeleton, Separator } from '@radix-ui/themes';

const BroadcastsSkeleton = () => {
  return (
    <Box p="5">
      <Flex gap="4" mb="3" align="center">
        <Skeleton width="200px" height="20px" />
        <Skeleton width="80px" height="20px" />
      </Flex>
      <Flex gap="4" mb="3" align="center">
        <Skeleton width="300px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
      </Flex>
      <Flex gap="4" mb="3" align="center">
        <Skeleton width="150px" height="16px" />
      </Flex>

      <Separator my="5" size="4" />

      <Flex gap="4" mb="3" align="center">
        <Skeleton width="200px" height="20px" />
        <Skeleton width="80px" height="20px" />
      </Flex>
      <Flex gap="4" mb="3" align="center">
        <Skeleton width="250px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
        <Skeleton width="60px" height="16px" />
      </Flex>
      <Flex gap="4" align="center">
        <Skeleton width="150px" height="16px" />
      </Flex>
    </Box>
  );
};

export default BroadcastsSkeleton;
